import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ShamCheckmarkIcon, ShamDeliveryTruck1Icon } from 'sham-components/icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-about-us-page',
  standalone: true,
  imports: [
    CommonModule,
    ShamDeliveryTruck1Icon,
    ShamCheckmarkIcon,
    TranslateModule
  ],
  templateUrl: './about-us-page.html',
  styleUrl: './about-us-page.css',
})
export class AboutUsPage {
  private readonly router = inject(Router);

  goHome(){
    this.router.navigate(['/home']);
  }
}
